/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { ReactNode } from "react";
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React TS components
import MDBox from "../../../../components/MDBox";
import MDTypography from "../../../../components/MDTypography";

// Declaring props types for DefaultInfoCard
interface Props {
  color?: "primary" | "secondary" | "info" | "success" | "warning" | "error" | "dark";
  icon: ReactNode;
  title: string;
  description?: string;
  value?: string | number;
  [key: string]: any;
  direction?: "left" | "right" | "center";
}

function DefaultInfoCard({ color, icon, title, description, direction, small }: Props): JSX.Element {
    return (
        <MDBox lineHeight={1} p={direction === "center" ? 2 : 0} textAlign={direction}>
          {typeof icon === "string" ? (
            <MDTypography
              display="block"
              variant={direction === "center" ? "h2" : "h3"}
              color={color}
              textGradient
            >
              {" "}
              <Icon>{icon}</Icon>{" "}
            </MDTypography>
          ) : (
            icon
          )}
          <MDTypography
            display="block"
            variant="5"
            fontWeight="bold"
            mt={direction === "center" ? 1 : 2}
            mb={1.5}
          >
            {title}
          </MDTypography>
          <MDTypography
            display="block"
            variant={small ? "button" : "body2"}
            color="text"
            pr={direction === "left" ? 6 : 0}
            pl={direction === "right" ? 6 : 0}
          >
            {description}
          </MDTypography>
        </MDBox>
      );
}

// Declaring default props for DefaultInfoCard
DefaultInfoCard.defaultProps = {
    color: "info",
    direction: "left",
    small: false,
};

export default DefaultInfoCard;
